import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import Filters from './Filters'
import _ from 'lodash'

class RenderFilters extends Component {
  constructor(props, context) {
    super(props, context)
  }

  renderFilters = () => {
    return (
      <div className="filter__box">
        <div className="filter__box-content">{this.renderAdvancedFilter()}</div>
      </div>
    )
  }

  renderAdvancedFilter = () => {
    const { showAdvnFilterBox, searchQuery } = this.props
    const searchKeys = Object.keys(searchQuery)
    if (searchKeys.includes('quickSearch')) {
      _.remove(searchKeys, function (key) {
        return key === 'quickSearch'
      })
    }

    return (
      <div
        className="ppvx_overflow-menu filter__container-advanced"
        ref={this.props.advnRef}
      >
        <div className="filter__content filter__content-advn">
          <a
            className="ppvx_link filter__header-label"
            onClick={(e) => this.props.setAdvnFilterBoxVisibility(e)}
          >
            <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-filter" />
            <Message id="filter.title" />
          </a>
        </div>
        {showAdvnFilterBox && this.renderAdvancedFilterOptions()}
      </div>
    )
  }

  renderAdvancedFilterOptions = () => {
    const { searchQuery, advnFilterBoxPosition } = this.props
    return (
      <Filters
        {...this.props}
        onFilterChange={this.props.onFilterChange}
        searchQuery={searchQuery}
        advnFilterBoxPosition={advnFilterBoxPosition}
      />
    )
  }

  render() {
    return <div>{this.renderFilters()}</div>
  }
}

export default RenderFilters
